module.exports = __webpack_public_path__ + "assets/key-success.34c33c8d.svg";